
export enum Color {
    Clear = "colorClear",
    Orange = "colorOrange",
    Yellow = "colorYellow",
    Red = "colorRed",
    Teal = "colorTeal",
  
    Dark = "colorDark",
    Light = "colorLight"
  
  }
  

export interface SelectableOption {
  label:string,
  value?:any,
  data?:any
  isDisabled?:boolean 
  isDivider?:boolean
  isHeading?:boolean 
  isSpinner?:boolean
  indent?:number
}